import { post } from 'app/utils/axios/kheti'

interface Response {
  detail: string
  sowing_record_id: string
}

const postFarmSowing = async (
  farmerId: string,
  sowingRecordId: string,
  farmId: string,
) => {
  try {
    const url = `/farmer-360/v1/farmer/${farmerId}/farm-sowing`
    return await post<Response>(url, {
      sowing_record_id: sowingRecordId,
      farm_id: farmId,
    })
  } catch (e) {
    return null
  }
}

export default postFarmSowing
